import { render, staticRenderFns } from "./DxIrrigationTable.vue?vue&type=template&id=ab77763c&"
import script from "./DxIrrigationTable.vue?vue&type=script&lang=js&"
export * from "./DxIrrigationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports